import type { MessageDescriptor } from 'react-intl'
import type { TripDetail } from 'tripPlanner/api/tripDetails'
import messages from './tripDetailsNudgeMessages'

export interface NudgeAnswer<Option extends string = string> {
  key: Option
  label: MessageDescriptor
  sentence: MessageDescriptor
}

export const ANSWERS = {
  destination: [
    { key: 'tropical', label: messages.tropicalLabel, sentence: messages.tropicalSentence },
    { key: 'open-to-ideas', label: messages.openToIdeasLabel, sentence: messages.openToIdeasSentence },
  ],
  dates: [
    { key: 'next-month', label: messages.nextMonthLabel, sentence: messages.nextMonthSentence },
    { key: 'flexible', label: messages.flexibleDatesLabel, sentence: messages.flexibleDatesSentence },
  ],
  travellers: [
    { key: 'two-of-us', label: messages.twoOfUsLabel, sentence: messages.twoOfUsSentence },
    { key: 'with-kids', label: messages.withKidsLabel, sentence: messages.withKidsSentence },
  ],
  budget: [
    { key: 'good-value', label: messages.goodValueLabel, sentence: messages.goodValueSentence },
    { key: 'splurge', label: messages.splurgeLabel, sentence: messages.splurgeSentence },
  ],
  preferences: [
    { key: 'relaxing', label: messages.relaxingLabel, sentence: messages.relaxingSentence },
    { key: 'adventurous', label: messages.adventurousLabel, sentence: messages.adventurousSentence },
  ],
} as const satisfies Record<TripDetail, readonly [NudgeAnswer, NudgeAnswer]>

/** Which answer was tapped, as analytics records it */
export type NudgeOption = (typeof ANSWERS)[TripDetail][number]['key']
